var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-bubble',{attrs:{"isMine":_vm.isMine,"message":_vm.message}},[_c('div',{staticClass:"sound-element-wrapper",attrs:{"title":"单击播放"},on:{"click":_vm.play}},[_c('i',{staticClass:"iconfont icon-voice"}),_vm._v("\r\n    "+_vm._s(_vm.second + '"')+"\r\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-281ca307","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/im/message/message-elements/sound-element.vue
// module id = null
// module chunks = 